import { useEffect, useState } from 'react';

export function useKeyboardOffset(threshold = 150) {
  const [keyboardOffset, setKeyboardOffset] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const vv = window.visualViewport;
      if (vv) {
        const offset = window.innerHeight - vv.height;
        setKeyboardOffset(offset > threshold ? offset : 0);
      }
    };

    window.visualViewport?.addEventListener('resize', handleResize);
    handleResize(); // Initial run

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
    };
  }, [threshold]);

  return keyboardOffset;
}
